module.exports = __webpack_public_path__ + "img/calendar.9d418300.svg";